<div class="list-item"
     [attr.data-empid]="employee.id"
     [attr.test-id]="employee.firstName+'-'+employee.lastName+'-'+cliRegNickName+'-'+contractDates"
     [class.cursor]="isEmployeeClickObserved"
     [class.active]="isSelected"
     [attr.role]="isEmployeeClickObserved ? 'button' : null"
     (click)="isEmployeeClickObserved ? employeeClick(employee, $event) : null"
>
  <div class="d-inline">
    <div class="list-left">
      <gp-user-avatar
        [pictureUri]="getPicture(employee)"
        [initials]="getInitials(employee)"></gp-user-avatar>
    </div>
    <div class="list-body">
      <div [class.inactive]="isInactive(employee?.empContracts)" class="employee-name">
        <span class="_500">{{ employee.lastName }}</span>
        {{ employee.firstName}}
      </div>
      <div class="intName">
              <span [class.inactive]="isInactive(employee?.empContracts)">
                ({{ employee.intLastName || ''}} {{employee.intFirstName || ''}})
              </span>
      </div>
      <small class="text-muted">{{ employee.employeeNumber }}</small>
    </div>
    <div class="list-footer">
      <span class="text-accent"
            *ngIf="employee.empContracts?.length && employee.empContracts[0].position">
        {{ employee.empContracts[0].position }}
      </span>
      <span>{{ 'EMPLOYEE_FORM.Contract_name' | translate:{name: cliRegNickName} }}</span>
      <span>{{ contractDates }}</span>
      <small class="pull-right" *ngIf="!employee.completed && displayIncomplete">
        <i style="color: red" class="fa fa-light fa-exclamation-circle" aria-hidden="true"></i>
      </small>
    </div>
  </div>
  <span *ngIf="!isIframe && isMenuClickObserved" class="menu-item dropdown" #dd>
    <button class="btn btn-outline btn-menu" type="button"
            (click)="menuClick(employee, $event)">
      <span class="fa fa-light fa-ellipsis-v"></span>
    </button>
  </span>
</div>
